import { render, staticRenderFns } from "./PatientRequestsForm.vue?vue&type=template&id=2dfbd2b6&scoped=true"
import script from "./PatientRequestsForm.vue?vue&type=script&lang=js"
export * from "./PatientRequestsForm.vue?vue&type=script&lang=js"
import style0 from "./PatientRequestsForm.vue?vue&type=style&index=0&id=2dfbd2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfbd2b6",
  null
  
)

export default component.exports